import { IWebchatTracking } from 'modules/webchat/domain/entities';
import {
  getRegistrationTrackingMeta,
  getSessionReferrer,
} from 'shared/presentation/helpers';

/**
 * O IP vem de um serviço externo dentro de getRegistrationTrackingMeta. Se ele
 * demorar, o chat abre sem esperar e leva só o que dá para ler na hora.
 */
export const WEBCHAT_TRACKING_TIMEOUT_MS = 3000;

/** Página em que o chat foi aberto, sem query string: ela pode carregar token ou dados pessoais. */
const getCurrentPage = () =>
  `${window.location.origin}${window.location.pathname}`;

const waitForTimeout = () =>
  new Promise<null>(resolve => {
    window.setTimeout(() => resolve(null), WEBCHAT_TRACKING_TIMEOUT_MS);
  });

/**
 * Origem do visitante no clique em "Iniciar conversa": a mesma atribuição de
 * campanha do cadastro do cliente (ED-7201), mais a página do chat. Nunca
 * falha: sem o meta, o chat abre com a página e o referrer.
 */
export default async function getWebchatTracking(): Promise<IWebchatTracking> {
  const page = getCurrentPage();

  try {
    const meta = await Promise.race([
      getRegistrationTrackingMeta(),
      waitForTimeout(),
    ]);

    if (!meta) {
      const referrer = getSessionReferrer();

      return { page, ...(referrer ? { referrer } : {}) };
    }

    return { ...meta, page };
  } catch {
    return { page };
  }
}
